@if (box$ | async; as box) {
  @let files = box.files;

  @if (isNotEmptyArray(files)) {
    <div [class]="styleClass()">
      @let shouldTurnOnCarousel = isMoreThanOne(files);

      <p-carousel
        [showNavigators]="shouldTurnOnCarousel"
        [circular]="shouldTurnOnCarousel"
        [numScroll]="1"
        [numVisible]="1"
        [showIndicators]="shouldTurnOnCarousel"
        [value]="files">
        <ng-template
          #item
          let-file>
          <app-public-box-carousel-item
            [imageAlt]="file.alt"
            [imageSrc]="file.url" />
        </ng-template>
      </p-carousel>
    </div>
  }
} @else {
  <div [class]="styleClass()">
    <app-spinner-filled />
  </div>
}
